<template>
  <div class="vendor-trends-item-wrapper">
    <div class="dashboards-filters">
      <div class="dashboards-filters">
        <strong>{{ title }}</strong>
      </div>
      <div class="dashboards-filters dashboards-filters-date date-simple">
        <date-picker
          v-model="params.creation_date"
          format="D MMM"
          range-separator="-"
          :editable="false"
          :shortcuts="false"
          input-class="date-simple-input"
          range
          lang="en"
          class="dark"
        ></date-picker>
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.lsp"
          :options="lspList"
          field-name="Name"
          placeholder="LSP"
          :multiple="false"
          required
        />
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.sourceLanguage"
          placeholder="Source language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <language-picker
          :options="languagesList"
          v-model="params.targetLanguage"
          placeholder="Target language"
        ></language-picker>
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.industry_field"
          :options="industryFieldList"
          field-name="Name"
          placeholder="Industry sector(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.doc_type"
          :options="textCategoryList"
          field-name="Name"
          placeholder="Document type(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaModel"
          :options="qaModelsList"
          field-name="Name"
          placeholder="QA model(s)"
        />
      </div>

      <div class="dashboards-filters">
        <filter-multiselect
          v-model="params.qaMethod"
          :options="qaMethodsList"
          field-name="Name"
          placeholder="Method(s)"
        />
      </div>
    </div>
    <div style="position: relative">
      <pre-loader :preloader-status="graphicsLoader"></pre-loader>
      <chart-constructor v-if="seriesData.length > 0" :options="chartOptions" />
      <empty-block v-if="seriesData.length === 0" class="graphics-placeholder" :text="placeHolderText" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import props from './props';

export default Vue.extend({
  name: 'VendorTrendsMainItem',
  components: {
    'language-picker': () =>
      import('@/components/selectors/language/index.vue'),
    'filter-multiselect': () =>
      import('@/components/selectors/filterMultiple/index.vue'),
    'date-picker': () => import('vue2-datepicker'),
    'chart-constructor': () =>
      import('@/components/charts/chartConstructor/index.js'),
    'pre-loader': () => import('@/components/preloader/index.vue'),
    'empty-block': () => import('@/components/emptyContainer/index.vue'),
  },
  props: {
    ...props,
  },
  computed: {
    placeHolderText() {
      return this.value.lsp ? 'No data for these filters' : 'Select LSP to view data';
    },
    params: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      },
    },
    // Impementing this method in child components
    seriesData() {
      return Array();
    },
    chartOptions() {
      return {
        chart: {
          type: 'line',
        },
        title: {
          text: '',
        },
        tooltip: {
          formatter: function () {
            return `
              <p><b>Report ${moment.utc(this.x).format('MMM YYYY')} (${this.series.name})</b></p>
              <br>
              <p>Risk level: ${this.point.risk}</p>
              <br>
              <p>QA level: ${this.point.qa.level}</p>
              <br>
              <p>QA score: ${this.point.qa.score}</p>
              <br>
              <br>
              <p><b>Errors</b></p>
              <br>
              <p>Total: ${this.point.errors.total}</p>
              <br>
              <p>- serious: ${this.point.errors.serious}</p>
              <br>
              <p>- minor: ${this.point.errors.minor}</p>
              <br>
              <br>
              <p>Total words: ${this.point.words}</p>
            `;
          },
        },
        xAxis: {
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: 'Quality score',
          },
        },
        legend: {
          enabled: true,
          layout: 'vertical',
          verticalAlign: 'middle',
          align: 'right',
        },
        series: this.seriesData,
      };
    },
  },
});
</script>

<style lang="scss">
.vendor-trends-item-wrapper {
  margin-bottom: 50px;
  background: #fff;
}
.dashboards-filters {
  margin-bottom: 0!important;
  flex-flow: row wrap;
  height: auto;

  &-date {
    margin-left: 40px;
  }
}
</style>
